import { createTheme } from "@mui/material/styles";

// Public site theme - only used for notifications & spinners; the site itself is styled in css/site.css
const theme = createTheme({
  palette: {
    primary: {
      main: "#5E362C",
      contrastText: "#FEF9EF",
    },
    secondary: {
      main: "#5CE1E6",
      contrastText: "#5E362C",
    },
    background: {
      default: "#FEF9EF",
    },
    text: {
      primary: "#5E362C",
    },
  },
  typography: {
    fontFamily: "\"Wix Madefor Text\", Arial, sans-serif",
  },
});

export default theme;
